import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ProfileAnalysis from './ProfileAnalysis/Main.js'

import BasicPage from './Detailing/UserBasicEv.js'
import FinancePage from './LoanEmi/LoanReportsNew.js'

// import ContactsApps from './UserMobileContacts.container'

import LogsMainPage from '../../CustomerPages/LogsMainPage.js'
import Operations from '../../CustomerPages/operationsJourney.js'
// import APITracker from './APITracker'
import DocumentsMain from './DocumentsSection/Main.js'
import OverviewMain from './OverviewSection/Overview1.js';
class UserDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rawMsgData: [],
            msgData: '',
            loadarState: false,
            deviceData: '',
            deviceDataLoader: false,
            dataChange: this.props.dataChange,
            
        }
        this.topRef = React.createRef()
    }
    componentDidUpdate(prevProps) {
        if (prevProps.userVisiblePanel !== this.props.userVisiblePanel && this.props.userVisiblePanel === 7) {
            this.topRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    render() {
        const { userVisiblePanel } = this.props;
        return (
            <div className="row height-81" >
                <div className="col-xs-12 no-padding full-height" style={{ background: userVisiblePanel === 2 ? '#fff' : '#fff',minHeight: '800px'}} ref={this.topRef}>
                    {this.userActiveView(userVisiblePanel)}
                </div>
            </div>
        )
    }

    componentDidMount() {
      
        this.setState({ dataChange: this.props.dataChange })
        const { allDetail } = this.props;
      
    }

    userActiveView(userVisiblePanel) {
        const { allStatus, allDetail, userDetails, admin, userDetail, creditScoringPopup, markCompleteBtn,tenant } = this.props;

        switch (userVisiblePanel) {
            case 0: return <OverviewMain
                allStatus={allStatus}
                allDetail={allDetail}
                userDetail={userDetails}
                admin={admin}
                tenant={tenant}
            />;
            case 1: return <BasicPage
                UserDetailTabsHandler={this.props.UserDetailTabsHandler}
                allStatus={allStatus}
                userDetailHandler={this.props.userDetailHandler}
                getData={this.props.getData.bind(this)}
                allDetail={allDetail}
                userDetail={userDetails}
                showCredit={this.state.loadarState}
                getCreditPopupState={this.getCreditPopupState.bind(this)}
                admin={admin}
                markCompleteBtn={markCompleteBtn}
                tenant={tenant}
            />;
            case 2: return <FinancePage getData={this.props.getData.bind(this)} allDetail={allDetail} userDetail={userDetails} admin={admin} tenant={tenant} />;

            case 3: return <ProfileAnalysis
                allDetail={allDetail}
                userDetail={userDetails}
                loadarState={this.state.loadarState}
                msgData={this.state.msgData}
                deviceData={this.state.deviceData}
                admin={admin}
                deviceDataLoader={this.state.deviceDataLoader}
                tenant={tenant}
                
            />;
            
            case 4: return <LogsMainPage allDetail={allDetail} userDetail={userDetails} />
            case 5: return <Operations userDetail={userDetails} allDetail={allDetail} admin={admin} markCompleteBtn={markCompleteBtn} />;
            // case 5: return <ContactsApps
            //     allDetail={allDetail}
            //     admin={admin}
            //     deviceData={this.state.deviceData}
            //     deviceDataLoader={this.state.deviceDataLoader}
            // />
            // case 6: return <APITracker allDetail={allDetail} userDetail={userDetails} />
             case 6: return <DocumentsMain allDetail={allDetail} userDetail={userDetails} />
            
           
            default: return;
        }
    }

    getCreditPopupState(state) {
        this.props.getCreditPopupState(state)
    }

    componentWillUnmount() {

    }
}


const mapStateToProps = ({ CRMMenu, allUserDetails }) => {
    return {
        userVisiblePanel: CRMMenu.UserOptions.selectedNavProp,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);